import { branding } from 'app/branding';
import { useIsPdfFormat } from 'hooks/use-is-pdf-format';

export const Footer = () => {
  const isPdfFormat = useIsPdfFormat();
  return isPdfFormat ? <></> : branding.footer;
};
